import { render, staticRenderFns } from "./ParametersTab.vue?vue&type=template&id=05b67272&"
import script from "./ParametersTab.vue?vue&type=script&lang=js&"
export * from "./ParametersTab.vue?vue&type=script&lang=js&"
import style0 from "./ParametersTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports